import React from "react";
import { useLocation } from "react-router-dom";
import AdSenseUnit from "@/components/ads/AdSenseUnit";
import { AD_SLOTS } from "@/config/adSlots";
import { AD_LABEL, getAdContainerClass, isAdsenseAllowedPath } from "@/lib/adsensePolicy";

const slotByPlacement = {
  display: AD_SLOTS.display,
  inFeed: AD_SLOTS.inFeed,
  inArticle: AD_SLOTS.inArticle,
};

const minHeightByPlacement = {
  display: 280,
  inFeed: 200,
  inArticle: 250,
};

export default function AdSenseAd({
  placement = "display",
  slot,
  format = "auto",
  layout,
  layoutKey,
  className = "",
}) {
  const location = useLocation();
  const selectedSlot = slot || slotByPlacement[placement];
  const minHeight = minHeightByPlacement[placement] || 250;

  if (!selectedSlot || !isAdsenseAllowedPath(location.pathname, location.search)) return null;

  return (
    <aside
      aria-label={AD_LABEL}
      className={getAdContainerClass(className)}
      style={{ minHeight }}
    >
      <div className="mb-1 text-center text-[11px] uppercase tracking-wide text-muted-foreground/70">
        {AD_LABEL}
      </div>
      <AdSenseUnit
        slot={selectedSlot}
        format={format}
        layout={layout}
        layoutKey={layoutKey}
        responsive
        style={{ display: "block", minHeight }}
      />
    </aside>
  );
}